// QuotationsPending.jsx
import { useNavigate } from "react-router-dom";
import quotationsData from "../../../data/quotationsData";

function money(n) {
  return `₹${n.toLocaleString("en-IN")}`;
}

const statusStyles = {
  Draft: "bg-gray-100 text-gray-600",
  Published: "bg-blue-50 text-blue-700",
  "Quotations Received": "bg-indigo-50 text-indigo-700",
  "Under Evaluation": "bg-amber-50 text-amber-700",
  "Quotation Selected": "bg-emerald-50 text-emerald-700",
  "Work Order Initiated": "bg-emerald-50 text-emerald-700",
  "In Development": "bg-emerald-50 text-emerald-700",
  Completed: "bg-gray-100 text-gray-600",
};

export default function QuotationsPending() {
  const navigate = useNavigate();

  const pendingQuotations = quotationsData.filter((q) =>
    ["Draft", "Published"].includes(q.status)
  );

  const openEnquiries = pendingQuotations.filter((q) =>
    ["Draft", "Published"].includes(q.status)
  ).length;

  return (
    <div>
      {/* Summary stats */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
        <div className="bg-white border border-gray-100 rounded-2xl p-3">
          <p className="text-xs font-semibold text-gray-400 tracking-wide">OPEN ENQUIRIES</p>
          <p className="text-2xl font-extrabold text-gray-900">{openEnquiries}</p>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white border border-gray-100 rounded-2xl overflow-auto mb-8">
        <table className="w-full text-sm">
          <thead style={{backgroundColor:"#f9fbfe"}}>
            <tr className="border-b border-gray-100 text-left text-xs font-semibold text-gray-400 tracking-wide">
              <th className="px-5 py-3">Enquiry</th>
              <th className="px-5 py-3">Category</th>
              <th className="px-5 py-3">Budget</th>
              <th className="px-5 py-3">Target</th>
              <th className="px-5 py-3">Quotations</th>
              <th className="px-5 py-3">Status</th>
              <th className="px-5 py-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {pendingQuotations.length === 0 ? (
              <tr>
                <td colSpan={6} className="px-5 py-10 text-center text-gray-400">
                  No pending enquiries. All your enquiries have received quotations.
                </td>
              </tr>
            ) : (
              pendingQuotations.map((q) => (
                <tr
                  key={q.id}
                  className="border-b border-gray-50 last:border-0 hover:bg-gray-50/60 transition"
                >
                  <td className="px-5 py-4" style={{ whiteSpace:"nowrap"}}>
                    <p className="font-semibold text-gray-900">{q.title}</p>
                    <p className="text-xs text-gray-400">{q.id}</p>
                  </td>
                  <td className="px-5 py-4 text-gray-600">{q.category}</td>
                  <td className="px-5 py-4 text-gray-600 whitespace-nowrap">
                    {money(q.budgetMin)} – {money(q.budgetMax)}
                  </td>
                  <td className="px-5 py-4 text-gray-600 whitespace-nowrap">
                    {q.targetDate}
                  </td>
                   <td className="px-5 py-4 text-gray-600">
                    {q.quotes.length}
                  </td>
                  <td className="px-5 py-4">
                    <span
                      className={`text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap ${
                        statusStyles[q.status] || "bg-gray-100 text-gray-600"
                      }`}
                    >
                      {q.status}
                    </span>
                  </td>
                  <td className="px-5 py-4">
                    <button
                      type="button"
                      onClick={() => navigate(`/app/quotations/${q.id}`)}
                      className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-8 rounded-md px-3 text-xs"
                    >
                      Compare →
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}


// // QuotationsPending.jsx
// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Loader2 } from "lucide-react";
// import enquiryService from "../../../service/enquiryService";

// function money(n) {
//   return `₹${n.toLocaleString("en-IN")}`;
// }

// const statusStyles = {
//   DRAFT: "bg-gray-100 text-gray-600",
//   PUBLISHED: "bg-blue-50 text-blue-700",
//   QUOTATIONS_RECEIVED: "bg-indigo-50 text-indigo-700",
//   UNDER_EVALUATION: "bg-amber-50 text-amber-700",
//   QUOTATION_SELECTED: "bg-emerald-50 text-emerald-700",
//   WORK_ORDER_INITIATED: "bg-emerald-50 text-emerald-700",
//   IN_DEVELOPMENT: "bg-emerald-50 text-emerald-700",
//   COMPLETED: "bg-gray-100 text-gray-600",
// };

// // Format status for display
// const formatStatus = (status) => {
//   if (!status) return "Draft";
//   return status
//     .split("_")
//     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//     .join(" ");
// };

// // Format budget range for display
// const formatBudgetRange = (budget) => {
//   if (!budget) return "Budget TBD";
  
//   const budgetMap = {
//     "BELOW_50000": "Below ₹50,000",
//     "BETWEEN_50000_AND_100000": "₹50,000 – ₹1,00,000",
//     "BETWEEN_100000_AND_500000": "₹1,00,000 – ₹5,00,000",
//     "ABOVE_500000": "Above ₹5,00,000",
//   };
  
//   return budgetMap[budget] || budget;
// };

// export default function QuotationsPending() {
//   const navigate = useNavigate();
//   const [enquiries, setEnquiries] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   const userId = localStorage.getItem('userId');

//   useEffect(() => {
//     if (userId) {
//       fetchEnquiries();
//     } else {
//       setError("User not logged in. Please login again.");
//       setLoading(false);
//     }
//   }, [userId]);

//   const fetchEnquiries = async () => {
//     setLoading(true);
//     setError("");

//     try {
//       const response = await enquiryService.getEnquiriesByUser(userId);
//       console.log("Raw API response:", response);

//       let enquiriesData = [];
//       if (Array.isArray(response)) {
//         enquiriesData = response;
//       } else if (response?.data && Array.isArray(response.data)) {
//         enquiriesData = response.data;
//       } else if (response?.success && response?.data && Array.isArray(response.data)) {
//         enquiriesData = response.data;
//       } else {
//         enquiriesData = [];
//         setError(response?.message || "No enquiries found.");
//       }
      
//       console.log("All enquiries:", enquiriesData);
      
//       // ✅ Filter pending enquiries with status "DRAFT"
//       const pendingEnquiries = enquiriesData.filter((q) => {
//         const status = q.enquiryStatus || q.status || "";
//         console.log("Enquiry:", q.id, "Status:", status);
//         return status === "DRAFT";
//       });
      
//       console.log("Pending enquiries count:", pendingEnquiries.length);
//       setEnquiries(pendingEnquiries);
//     } catch (err) {
//       console.error("Error fetching enquiries:", err);
//       setError(err.message || "Failed to load enquiries. Please try again.");
//       setEnquiries([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const openEnquiries = enquiries.length;

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <Loader2 className="w-8 h-8 text-indigo-600 animate-spin" />
//         <span className="ml-3 text-gray-600">Loading enquiries...</span>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="h-40 flex items-center justify-center text-red-500 border border-red-200 bg-red-50 rounded-2xl">
//         {error}
//       </div>
//     );
//   }

//   return (
//     <div>
//       {/* Summary stats */}
//       <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
//         <div className="bg-white border border-gray-100 rounded-2xl p-3">
//           <p className="text-xs font-semibold text-gray-400 tracking-wide">OPEN ENQUIRIES</p>
//           <p className="text-2xl font-extrabold text-gray-900">{openEnquiries}</p>
//         </div>
//       </div>

//       {/* Table */}
//       <div className="bg-white border border-gray-100 rounded-2xl overflow-auto mb-8">
//         <table className="w-full text-sm">
//           <thead style={{backgroundColor:"#f9fbfe"}}>
//             <tr className="border-b border-gray-100 text-left text-xs font-semibold text-gray-400 tracking-wide">
//               <th className="px-5 py-3">Enquiry</th>
//               <th className="px-5 py-3">Category</th>
//               <th className="px-5 py-3">Budget</th>
//               <th className="px-5 py-3">Target</th>
//               <th className="px-5 py-3">Quotations</th>
//               <th className="px-5 py-3">Status</th>
//               <th className="px-5 py-3">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {enquiries.length === 0 ? (
//               <tr>
//                 <td colSpan={7} className="px-5 py-10 text-center text-gray-400">
//                   No pending enquiries. All your enquiries have received quotations.
//                 </td>
//               </tr>
//             ) : (
//               enquiries.map((q) => (
//                 <tr
//                   key={q.id}
//                   className="border-b border-gray-50 last:border-0 hover:bg-gray-50/60 transition"
//                 >
//                   <td className="px-5 py-4" style={{ whiteSpace:"nowrap"}}>
//                     <p className="font-semibold text-gray-900">{q.projectName || "Untitled"}</p>
//                     <p className="text-xs text-gray-400">{q.id || q.enquiryId}</p>
//                   </td>
//                   <td className="px-5 py-4 text-gray-600">
//                     {q.productCategory || q.category || "General"}
//                   </td>
//                   <td className="px-5 py-4 text-gray-600 whitespace-nowrap">
//                     {formatBudgetRange(q.expectedBudgetRange)}
//                   </td>
//                   <td className="px-5 py-4 text-gray-600 whitespace-nowrap">
//                     {q.targetDeliveryDate || "TBD"}
//                   </td>
//                   <td className="px-5 py-4 text-gray-600">
//                     {q.quotationsCount || q.quotes?.length || 0}
//                   </td>
//                   <td className="px-5 py-4">
//                     <span
//                       className={`text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap ${
//                         statusStyles[q.enquiryStatus || q.status] || "bg-gray-100 text-gray-600"
//                       }`}
//                     >
//                       {formatStatus(q.enquiryStatus || q.status)}
//                     </span>
//                   </td>
//                   <td className="px-5 py-4">
//                     <button
//                       type="button"
//                       onClick={() => navigate(`/app/quotations/${q.id || q.enquiryId}`)}
//                       className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-8 rounded-md px-3 text-xs"
//                     >
//                       Compare →
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }